import { render, staticRenderFns } from "./forgetPw.vue?vue&type=template&id=71df546b&scoped=true&"
import script from "./forgetPw.vue?vue&type=script&lang=js&"
export * from "./forgetPw.vue?vue&type=script&lang=js&"
import style0 from "./forgetPw.vue?vue&type=style&index=0&id=71df546b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71df546b",
  null
  
)

export default component.exports